const actions = {
	GET_ANSWER_SHORT_QUESTION: 'GET_ANSWER_SHORT_QUESTION',
	GET_ANSWER_SHORT_QUESTION_SUCCESS: 'GET_ANSWER_SHORT_QUESTION_SUCCESS',

	CREATE_NEW_QUESTION_ANSWER_SHORT_QUESTION: 'CREATE_NEW_QUESTION_ANSWER_SHORT_QUESTION',
	CREATE_NEW_QUESTION_ANSWER_SHORT_QUESTION_SUCCESS: 'CREATE_NEW_QUESTION_ANSWER_SHORT_QUESTION_SUCCESS',

	DELETE_ANSWER_SHORT_QUESTION: 'DELETE_ANSWER_SHORT_QUESTION',
	DELETE_ANSWER_SHORT_QUESTION_SUCCESS: 'DELETE_ANSWER_SHORT_QUESTION_SUCCESS',

	GET_ANSWER_SHORT_QUESTION_DETAIL: 'GET_ANSWER_SHORT_QUESTION_DETAIL',
	GET_ANSWER_SHORT_QUESTION_DETAIL_SUCCESS: 'GET_ANSWER_SHORT_QUESTION_DETAIL_SUCCESS',

	UPDATE_ANSWER_SHORT_QUESTION_DETAIL: 'UPDATE_ANSWER_SHORT_QUESTION_DETAIL',
	UPDATE_ANSWER_SHORT_QUESTION_DETAIL_SUCCESS: 'UPDATE_ANSWER_SHORT_QUESTION_DETAIL_SUCCESS',

	SPEAKING_LOADING_FALSE: 'SPEAKING_LOADING_FALSE',
	//#region CRUD

	getAnswerShortQuestion: (model) => ({
		type: actions.GET_ANSWER_SHORT_QUESTION,
		payload: { model },
	}),

	createQuesAnswerShortQuestion: (body, cbSuccess, cbError) => ({
		type: actions.CREATE_NEW_QUESTION_ANSWER_SHORT_QUESTION,
		payload: { body },
		cbSuccess,
		cbError,
	}),

	getAnswerShortQuestionDetail: (id) => ({
		type: actions.GET_ANSWER_SHORT_QUESTION_DETAIL,
		payload: { id },
	}),

	updateAnswerShortQuestionDetail: (model, cbSuccess, cbError) => ({
		type: actions.UPDATE_ANSWER_SHORT_QUESTION_DETAIL,
		payload: { model },
		cbSuccess,
		cbError,
	}),

	deleteAnswerShortQuestion: (id, cbSuccess, cbError) => ({
		type: actions.DELETE_ANSWER_SHORT_QUESTION,
		payload: { id },
		cbSuccess,
		cbError,
	}),
};

export default actions;
